export enum InputRuleKinds {
  // bitマスクで状態を表現する事も考えたが変な拡張はないと思うので単純な連番で.
  None = 0,
  FullWidthOnly = 1,
  FullWidthKanaOnly = 2,
  HalfWidthKanaOnly = 3,
  HalfWidthNumberOnly = 4,
  HalfWidthAlphabetAndNumberOnly = 5,
}
